import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from './../../../../environments/environment';
import { ServiceCRUD } from './../../../shared/crud/ServiceCRUD';
import { Parametro } from '../usuario-fabrica-cadastro/parametro';
import { Observable } from 'rxjs';

@Injectable()
export class UsuarioFabricaService
extends ServiceCRUD {

  url = environment.URL_API + '/usuario_fabrica';
  
  constructor(http: HttpClient, router: Router) {
    super(http, router);
  }

  protected getURL(): string {
    return this.url;  
  }
  getFiltroDealers(): any {
    this.url = `${environment.URL_API}/filtro/dealer_filtrado`;
    var retorno = this.get([]);
    this.url = `${environment.URL_API}/usuario_fabrica`;

    return retorno;
  }

  getDealersRestantes(idDealer: any): any {
    this.url = `${environment.URL_API}/filtro/dealer_filtrado?idDealer=${idDealer}`;
    var retorno = this.get([]);
    this.url = `${environment.URL_API}/usuario_fabrica`;

    return retorno;
  }

  private gerarListaParametros(dealer): any[] {
    const parametros: Parametro[] = [];

    const itemDealer = new Parametro('dealer', dealer);
    parametros.push(itemDealer);

    return parametros;
  }

  incluirDealer(path: string, dealer: number): Promise<any> {
    const parametros = this.gerarListaParametros(dealer);
    return this.atualizar({}, parametros);
  }

}
